import { PlusCircle } from "@/styles/icons";
import { useState } from "react";
import { Button, Modal } from "barte-design-system";

interface Step {
  title: string;
  content: React.ReactNode;
  onNext?: () => void;
  onBack?: () => void;
}

interface FormModalProps {
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  handleConfirmModal: () => void;
  title: string;
  confirmationButtonText?: string;
  disableWhenIsFormEmpty?: boolean;
  type?: "ADD" | "EDIT" | "DELETE";
  steps?: Step[];
  isCentered?: boolean;
}

const FormModal2: React.FC<FormModalProps> = ({
  isOpen,
  isSubmitting,
  onClose,
  handleConfirmModal,
  title,
  confirmationButtonText = "Adicionar",
  disableWhenIsFormEmpty = false,
  type,
  steps,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const totalSteps = steps?.length || 0;

  function formatIconType(type) {
    const iconTypes = {
      ADD: <PlusCircle />,
      EDIT: <></>,
      DELETE: <></>,
    }
    return iconTypes[type] || <></>;
  }

  const handleNext = () => {
    if (currentStep < totalSteps - 1) {
      steps?.[currentStep]?.onNext?.();
      setCurrentStep(currentStep + 1);
    } else {
      handleConfirmModal();
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      steps?.[currentStep]?.onBack?.();
      setCurrentStep(currentStep - 1);
    }
  };

  const renderProgressBar = () => {
    if (!steps || steps.length <= 1) return null;

    const progressPercent = ((currentStep + 1) / totalSteps) * 100;

    return (
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
          <span style={{ fontSize: "14px", color: "#718096" }}>
            Passo {currentStep + 1} de {totalSteps}
          </span>
          <span style={{ fontSize: "14px", color: "#718096" }}>
            {steps[currentStep]?.title}
          </span>
        </div>
        <div style={{ width: "100%", height: "4px", backgroundColor: "#EDF2F7", borderRadius: "2px" }}>
          <div style={{ width: `${progressPercent}%`, height: "100%", backgroundColor: "#ED64A6", borderRadius: "2px", transition: "width 0.2s" }} />
        </div>
      </div>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      className="modal-viewport-capped"
      footer={{
        primaryButton: {
          id: confirmationButtonText === "Adicionar" ? "recebimento_manual" : "",
          children: currentStep === totalSteps - 1 ? confirmationButtonText : "Próximo",
          disabled: isSubmitting || disableWhenIsFormEmpty,
          loading: isSubmitting,
          onClick: handleNext,
        },
        ...(currentStep > 0 ? {
          secondaryButton: {
            children: "Voltar",
            onClick: handleBack,
            variant: "outline",
          }
        } : {}),
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {formatIconType(type)}
        {renderProgressBar()}
        {steps[currentStep]?.content}
      </div>
    </Modal>
  );
};

export { FormModal2 }
